// Lazy route imports (`() => import('./Foo.vue')`) reference hashed chunk
// filenames. After a deploy the old hashes are gone, so the import 404s and
// vue-router emits an error that — without this guard — vanishes silently
// (GlitchTip backend #31/#390/#383). The wording differs per browser.
const CHUNK_LOAD_PATTERNS = [
    /failed to fetch dynamically imported module/i,
    /error loading dynamically imported module/i,
    /importing a module script failed/i,
]

export function isChunkLoadError(error: unknown): boolean {
    if (error === null || error === undefined) return false
    const message = error instanceof Error
        ? error.message
        : typeof error === "string"
            ? error
            : String(error)
    return CHUNK_LOAD_PATTERNS.some((pattern) => pattern.test(message))
}
